export const createRandomId = (prefix?: string) =>
  `${prefix || ''}${(Math.random() + 1).toString(36)}`;
